import GetMonthlyPayment from "./monthlyPayment";

const GetTotalInterestTime = (
  loanAmount,
  annualRate,
  loanTermYears,
  extraRepayment
) => {
  const monthlyRate = Number(annualRate) / 100 / 12; // Monthly interest rate

  const nPayments = Number(loanTermYears) * 12; // Total number of payments

  const monthlyRepayment = GetMonthlyPayment(
    loanAmount,
    annualRate,
    loanTermYears
  );

  let currentBalance = Number(loanAmount);
  let totalInterest = 0;
  let totalMonths = 1;

  for (let month = 1; month <= nPayments; month++) {
    let interest = currentBalance * monthlyRate; // Interest for the current period

    let principal = monthlyRepayment - interest; // Principal portion of the repayment

    let totalRepayment = principal + interest + Number(extraRepayment);

    // Adjust for the final payment
    if (totalRepayment >= currentBalance) {
      principal = currentBalance;

      interest = currentBalance * monthlyRate;

      totalRepayment = principal + interest;

      currentBalance = 0;
    } else {
      currentBalance -= principal + Number(extraRepayment);
    }

    totalInterest += interest;
    totalMonths = month;

    // Break if the loan is fully paid
    if (currentBalance <= 0) break;
  }
  return { totalInterest, totalMonths };
};

export default GetTotalInterestTime;
